import { useEffect, useRef, useState } from "react";
import { Card, Col, Collapse, Form, Row } from "react-bootstrap";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const Filters = ({ selectedOption, selectedItems, setSelectedItems }) => {
    let [isOpen, setIsOpen] = useState(false);
    let [options, setOptions] = useState([
        { id: 1, name: 'Synozon Technology', website: 'Synozon.com' },
        { id: 2, name: 'Sysco Technology', website: 'Sysco.com' },
        { id: 3, name: 'Synthetic Technology', website: 'Synthetic.com' },
        { id: 4, name: 'Digylax Pvt Ltd', website: 'Digylax.com' },
    ]);

    let [agricultureAndMining, setAgricultureAndMining] = useState([
        { id: 'aam1', name: 'Farming' }, { id: 'aam2', name: 'Dairy' }, { id: 'aam3', name: 'Tobacco' },
        { id: 'aam4', name: 'Fishery' }, { id: 'aam5', name: 'Mining & Metals' }, { id: 'aam6', name: 'Ranching' },
    ]);

    let [businessServices, setBusinessServices] = useState([
        { id: 'bs1', name: 'Design' }, { id: 'bs2', name: 'Event Services' }, { id: 'bs3', name: 'Human Resources' },
        { id: 'bs4', name: 'Environmental Services' }, { id: 'bs5', name: 'Market Research' }, { id: 'bs6', name: 'Business Supplies and Equipment' },
        { id: 'bs7', name: 'Public Safety' }, { id: 'bs8', name: 'Think Tanks' }, { id: 'bs9', name: 'Law Enforcement' },
        { id: 'bs10', name: 'Facilities Services' }, { id: 'bs11', name: 'Import and Export' }, { id: 'bs12', name: 'Graphic Design' },
        { id: 'bs13', name: 'Executive Office' }, { id: 'bs14', name: 'Writing and Editing' }, { id: 'bs15', name: 'Program Development' },
        { id: 'bs16', name: 'Animation' }, { id: 'bs17', name: 'Alternative Dispute Resolution' }, { id: 'bs18', name: 'Translation and Localization' },
        { id: 'bs19', name: 'International Trade and Development' }, { id: 'bs20', name: 'Law Practice' }, { id: 'bs21', name: 'Legal Services' },
        { id: 'bs22', name: 'Management Consulting' }, { id: 'bs23', name: 'Marketing and Advertising' }, { id: 'bs24', name: 'Professional Training & Coaching' },
        { id: 'bs25', name: 'Public Relations and Communications' }, { id: 'bs26', name: 'Security and Investigations' }, { id: 'bs27', name: 'Staffing and Recruiting' },
    ]);

    let [computerEletronics, setComputerEletronics] = useState([
        { id: 'ce1', name: 'Computer Hardware' }, { id: 'ce2', name: 'Computer Networking' }, { id: 'ce3', name: 'Semiconductors' },
        { id: 'ce4', name: 'Consumer Electronics' }, { id: 'ce5', name: 'Ethernet' }, { id: 'ce6', name: 'Information Technology and Services' },
        { id: 'ce7', name: 'Internet' }, { id: 'ce8', name: 'Semiconductors' }, { id: 'ce9', name: 'Telecommunications' },
        { id: 'ce10', name: 'Wireless' }, { id: 'ce11', name: 'Computer Games' }, { id: 'ce12', name: 'E-Learning' },
        { id: 'ce13', name: 'Information Services' }, { id: 'ce14', name: 'Information Technology and Services' }, { id: 'ce15', name: 'Internet' },
    ]);

    let [consumerServices, setConsumerServices] = useState([
        { id: 'cs1', name: 'Consumer Goods' }, { id: 'cs2', name: 'Individual & Family Services' }, { id: 'cs3', name: 'Photography' },
        { id: 'cs4', name: 'Restaurants' },
    ]);

    const dropdownRef = useRef(null);
    // let [selectedOptions, setSelectedOptions] = useState([])

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleSelect = (e, option) => {
        if (e.target.checked) {
            // Add the object to the selectedItems array if checked
            setSelectedItems((prevItems) => [...prevItems, option]);
        } else {
            // Remove the object from the selectedItems array if unchecked
            setSelectedItems((prevItems) =>
                prevItems.filter(item => item.id !== option.id)
            );
        }

        // setSelectedItems((prevSelectedItems) => {
        //     if (prevSelectedItems.some((selectedItem) => selectedItem.id === option.id)) {
        //         return prevSelectedItems.filter((selectedItem) => selectedItem.id !== option.id);
        //     } else {
        //         return [...prevSelectedItems, option];
        //     }
        // });
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Card collapse for Agriculture & Farming
    const [agricultureAndMiningOpen, setAgricultureAndMiningOpen] = useState(true);
    // Handler for "select all" checkbox in Agriculture & Farming
    const handleAgricultureAndMiningSelectAll = (e) => {
        const checked = e.target.checked;
        setSelectedItems(prev => {
            if (checked) {
                // Add all not already selected
                const newItems = agricultureAndMining.filter(opt =>
                    !prev.some(item => item.id === opt.id)
                );
                return [...prev, ...newItems];
            } else {
                // Remove all in agricultureAndMining
                return prev.filter(item =>
                    !agricultureAndMining.some(opt => opt.id === item.id)
                );
            }
        });
    };
    // Compute checked and indeterminate state for "select all" checkbox
    const agricultureAllChecked = agricultureAndMining.length > 0 && agricultureAndMining.every(opt => selectedItems.some(item => item.id === opt.id));
    // Indeterminate state if some but not all are selected
    const agricultureIndeterminate = selectedItems.some(item => agricultureAndMining.some(opt => opt.id === item.id)) && !agricultureAllChecked;

    // Card collapse for Business Services
    const [businessServicesOpen, setBusinessServicesOpen] = useState(true);
    // Handler for "select all" checkbox in Business Services
    const handleBusinessServicesSelectAll = (e) => {
        const checked = e.target.checked;
        setSelectedItems(prev => {
            if (checked) {
                // Add all not already selected
                const newItems = businessServices.filter(opt =>
                    !prev.some(item => item.id === opt.id)
                );
                return [...prev, ...newItems];
            } else {
                // Remove all in businessServices
                return prev.filter(item =>
                    !businessServices.some(opt => opt.id === item.id)
                );
            }
        });
    };
    // Compute checked and indeterminate state for "select all" checkbox
    const businessServicesAllChecked = businessServices.length > 0 && businessServices.every(opt => selectedItems.some(item => item.id === opt.id));
    // Indeterminate state if some but not all are selected
    const businessServicesIndeterminate = selectedItems.some(item => businessServices.some(opt => opt.id === item.id)) && !businessServicesAllChecked;

    // Card collapse for Computers & Electronics
    const [computerEletronicsOpen, setComputerEletronicsOpen] = useState(true);
    // Handler for "select all" checkbox in Computers & Electronics
    const handleComputerEletronicsSelectAll = (e) => {
        const checked = e.target.checked;
        setSelectedItems(prev => {
            if (checked) {
                // Add all not already selected
                const newItems = computerEletronics.filter(opt =>
                    !prev.some(item => item.id === opt.id)
                );
                return [...prev, ...newItems];
            } else {
                // Remove all in computerEletronics
                return prev.filter(item =>
                    !computerEletronics.some(opt => opt.id === item.id)
                );
            }
        });
    };
    // Compute checked and indeterminate state for "select all" checkbox
    const computerEletronicsAllChecked = computerEletronics.length > 0 && computerEletronics.every(opt => selectedItems.some(item => item.id === opt.id));
    // Indeterminate state if some but not all are selected
    const computerEletronicsIndeterminate = selectedItems.some(item => computerEletronics.some(opt => opt.id === item.id)) && !computerEletronicsAllChecked;

    // Card collapse for Consumer Services
    const [consumerServicesOpen, setConsumerServicesOpen] = useState(true);
    // Handler for "select all" checkbox in Consumer Services
    const handleConsumerServicesSelectAll = (e) => {
        const checked = e.target.checked;
        setSelectedItems(prev => {
            if (checked) {
                // Add all not already selected
                const newItems = consumerServices.filter(opt =>
                    !prev.some(item => item.id === opt.id)
                );
                return [...prev, ...newItems];
            } else {
                // Remove all in consumerServices
                return prev.filter(item =>
                    !consumerServices.some(opt => opt.id === item.id)
                );
            }
        });
    };
    // Compute checked and indeterminate state for "select all" checkbox
    const consumerServicesAllChecked = consumerServices.length > 0 && consumerServices.every(opt => selectedItems.some(item => item.id === opt.id));
    // Indeterminate state if some but not all are selected
    const consumerServicesIndeterminate = selectedItems.some(item => consumerServices.some(opt => opt.id === item.id)) && !consumerServicesAllChecked;

    return (<>
        {/* <Row className="mt-2">
            <div className="col-6" ref={dropdownRef}>
                <div className="dropdown">
                    <div
                        className="form-select d-flex align-items-center justify-content-between w-100 p-2 border"
                        onClick={toggleDropdown}
                        style={{ cursor: "pointer" }}
                    >
                        Select for {selectedOption}
                        <span className="dropdown-toggle ms-2"></span>
                    </div>
                    {isOpen && (
                        <div className="dropdown-menu w-100 show p-2" style={{ maxHeight: "200px", overflowY: "auto" }}>
                            {options.map((option) => (
                                <div key={option.id} className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={selectedItems.some(item => item.id === option.id)}
                                        onChange={(e) => handleSelect(e, option)}
                                        id={`companyFilter_${option.id}`}
                                    />
                                    <label htmlFor={`companyFilter_${option.id}`} className="form-check-label ms-2">{option.name}</label>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </Row> */}
        <div className="keywords-selection vstack gap-3 mt-2">
            {/* Collapse card for Agriculture & Farming */}
            <Card className="p-0">
                <Card.Header className="d-flex justify-content-between align-items-center" role="button"
                onClick={() => setAgricultureAndMiningOpen(!agricultureAndMiningOpen)}>
                    <div className="hstack">
                        <Form.Check type="checkbox" className="hstack my-2 ms-2 cursor-pointer">
                            <Form.Check.Input 
                                checked={agricultureAllChecked}
                                indeterminate={agricultureIndeterminate ? "indeterminate" : undefined}
                                onChange={handleAgricultureAndMiningSelectAll}
                                onClick={e => e.stopPropagation()}
                                id="agriculture-farming-checkbox"
                                className="fs-6 my-auto border-secondary-subtle cursor-pointer"
                            />
                        </Form.Check>
                        <Form.Check.Label className="ps-2 fw-medium cursor-pointer" onClick={e => e.stopPropagation()} htmlFor="agriculture-farming-checkbox">
                            Agriculture & Farming
                        </Form.Check.Label>
                    </div>
                    <span>
                        {agricultureAndMiningOpen ? <FaChevronUp className="bi" /> : <FaChevronDown className="bi" />}
                    </span>
                </Card.Header>
                <Collapse in={agricultureAndMiningOpen}>
                    <div>
                        <Card.Body>
                            <Row xs={2} md={3} className="g-3">
                                {agricultureAndMining.map((option, idx) => (
                                    <Col key={option.id || idx}>
                                        <Form.Check
                                            type="checkbox"
                                            label={option.name}
                                            checked={selectedItems.some(item => item.id === option.id)}
                                            onChange={(e) => handleSelect(e, option)}
                                            id={`agriculture-mining-${option.id}`}
                                        />
                                    </Col>
                                ))}
                            </Row>
                        </Card.Body>
                    </div>
                </Collapse>
            </Card>
            {/* // Collapse card for Agriculture & Farming END // */}
            {/* Collapse card for Business Services */}
            <Card className="p-0">
                <Card.Header className="d-flex justify-content-between align-items-center" role="button"
                onClick={() => setBusinessServicesOpen(!businessServicesOpen)}>
                    <div className="hstack">
                        <Form.Check type="checkbox" className="hstack my-2 ms-2 cursor-pointer">
                            <Form.Check.Input 
                                checked={businessServicesAllChecked}
                                indeterminate={businessServicesIndeterminate ? "indeterminate" : undefined}
                                onChange={handleBusinessServicesSelectAll}
                                onClick={e => e.stopPropagation()}
                                id="business-services-checkbox"
                                className="fs-6 my-auto border-secondary-subtle cursor-pointer"
                            />
                        </Form.Check>
                        <Form.Check.Label className="ps-2 fw-medium cursor-pointer" onClick={e => e.stopPropagation()} 
                        htmlFor="business-services-checkbox">
                            Business Services
                        </Form.Check.Label>
                    </div>
                    <span>
                        {businessServicesOpen ? <FaChevronUp className="bi" /> : <FaChevronDown className="bi" />}
                    </span>
                </Card.Header>
                <Collapse in={businessServicesOpen}>
                    <div>
                        <Card.Body>
                            <Row xs={2} md={3} className="g-3">
                                {businessServices.map((option, idx) => (
                                    <Col key={option.id || idx}>
                                        <Form.Check
                                            type="checkbox"
                                            label={option.name}
                                            checked={selectedItems.some(item => item.id === option.id)}
                                            onChange={(e) => handleSelect(e, option)}
                                            id={`business-services-${option.id}`}
                                        />
                                    </Col>
                                ))}
                            </Row>
                        </Card.Body>
                    </div>
                </Collapse>
            </Card>
            {/* // Collapse card for Business Services END // */}
            {/* Collapse card for Computers & Electronics */}
            <Card className="p-0">
                <Card.Header className="d-flex justify-content-between align-items-center" role="button"
                onClick={() => setComputerEletronicsOpen(!computerEletronicsOpen)}>
                    <div className="hstack">
                        <Form.Check type="checkbox" className="hstack my-2 ms-2 cursor-pointer">
                            <Form.Check.Input 
                                checked={computerEletronicsAllChecked}
                                indeterminate={computerEletronicsIndeterminate ? "indeterminate" : undefined}
                                onChange={handleComputerEletronicsSelectAll}
                                onClick={e => e.stopPropagation()}
                                id="computer-eletronics-checkbox"
                                className="fs-6 my-auto border-secondary-subtle cursor-pointer"
                            />
                        </Form.Check>
                        <Form.Check.Label className="ps-2 fw-medium cursor-pointer" onClick={e => e.stopPropagation()} 
                        htmlFor="computer-eletronics-checkbox">
                            Computer Eletronics
                        </Form.Check.Label>
                    </div>
                    <span>
                        {computerEletronicsOpen ? <FaChevronUp className="bi" /> : <FaChevronDown className="bi" />}
                    </span>
                </Card.Header>
                <Collapse in={computerEletronicsOpen}>
                    <div>
                        <Card.Body>
                            <Row xs={2} md={3} className="g-3">
                                {computerEletronics.map((option, idx) => (
                                    <Col key={option.id || idx}>
                                        <Form.Check
                                            type="checkbox"
                                            label={option.name}
                                            checked={selectedItems.some(item => item.id === option.id)}
                                            onChange={(e) => handleSelect(e, option)}
                                            id={`computer-eletronics-${option.id}`}
                                        />
                                    </Col>
                                ))}
                            </Row>
                        </Card.Body>
                    </div>
                </Collapse>
            </Card>
            {/* // Collapse card for Computers & Electronics END // */}
            {/* Collapse card for Consumer Services */}
            <Card className="p-0">
                <Card.Header className="d-flex justify-content-between align-items-center" role="button"
                onClick={() => setConsumerServicesOpen(!consumerServicesOpen)}>
                    <div className="hstack">
                        <Form.Check type="checkbox" className="hstack my-2 ms-2 cursor-pointer">
                            <Form.Check.Input 
                                checked={consumerServicesAllChecked}
                                indeterminate={consumerServicesIndeterminate ? "indeterminate" : undefined}
                                onChange={handleConsumerServicesSelectAll}
                                onClick={e => e.stopPropagation()}
                                id="consumer-services-checkbox"
                                className="fs-6 my-auto border-secondary-subtle cursor-pointer"
                            />
                        </Form.Check>
                        <Form.Check.Label className="ps-2 fw-medium cursor-pointer" onClick={e => e.stopPropagation()} 
                        htmlFor="consumer-services-checkbox">
                            Consumer Services
                        </Form.Check.Label>
                    </div>
                    <span>
                        {consumerServicesOpen ? <FaChevronUp className="bi" /> : <FaChevronDown className="bi" />}
                    </span>
                </Card.Header>
                <Collapse in={consumerServicesOpen}>
                    <div>
                        <Card.Body>
                            <Row xs={2} md={3} className="g-3">
                                {consumerServices.map((option, idx) => (
                                    <Col key={option.id || idx}>
                                        <Form.Check
                                            type="checkbox"
                                            label={option.name}
                                            checked={selectedItems.some(item => item.id === option.id)}
                                            onChange={(e) => handleSelect(e, option)}
                                            id={`consumer-services-${option.id}`}
                                        />
                                    </Col>
                                ))}
                            </Row>
                        </Card.Body>
                    </div>
                </Collapse>
            </Card>
            {/* // Collapse card for Consumer Services END // */}
        </div>
    </>)
}
export default Filters;